import { render, staticRenderFns } from "./DataProtection.vue?vue&type=template&id=4131102e&scoped=true&lang=pug&"
import script from "./DataProtection.vue?vue&type=script&lang=ts&"
export * from "./DataProtection.vue?vue&type=script&lang=ts&"
import style0 from "./DataProtection.vue?vue&type=style&index=0&id=4131102e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4131102e",
  null
  
)

export default component.exports